/**
 * Created by alex.y on 10/12/2017.
 */
export class BaseModifyRequest {
    public ChangeForAllOrders : boolean;
}


// WEBPACK FOOTER //
// ./app/objects/requests/baseModifyRequest.ts